module.exports = __webpack_public_path__ + "img/zuofeihong.a7b0c439.jpg";